import { Navigate } from "react-router-dom";

import { IframeLoginFlow } from "@src/features/iframe";

import {
  useEmailPasswordLoginFlow,
  useIframeAuthLoginFlow,
  useLoginWithElationFlow,
} from "../../../application/v2";
import { UnauthenticatedLayoutV2 } from "../../../ui/layout/v2";
import { IframeLoginPageV2 } from "../../../ui/pages/v2/IframeLoginPage";
import { LoginPageV2 } from "../../../ui/pages/v2/LoginPage";

export default function LoginV2Route() {
  const emailPassword = useEmailPasswordLoginFlow();
  const elation = useLoginWithElationFlow();
  const iframe = useIframeAuthLoginFlow();

  if (iframe.enabled) {
    return (
      <IframeLoginFlow
        isLoading={iframe.isLoading}
        error={iframe.error}
        session={iframe.session}
        destinations={iframe.destinations}
        view={IframeLoginPageV2}
      />
    );
  }

  if (emailPassword.existingSessionDestination) {
    return <Navigate to={emailPassword.existingSessionDestination} replace />;
  }

  return (
    <UnauthenticatedLayoutV2>
      <LoginPageV2
        error={emailPassword.error ?? elation.error}
        isSubmitting={emailPassword.isSubmitting || elation.isSubmitting}
        onLoginWithElation={elation.enabled ? elation.login : undefined}
        onSubmit={emailPassword.submit}
      />
    </UnauthenticatedLayoutV2>
  );
}
